/**
 * BarChartRama — bar chart counts por rama.
 *
 * Per FWA-PWA-032 G0 D4. Recharts declarative + responsive.
 * Datos agregados sin PII individual (per privacy.md §6.1).
 */
import type { PorRamaCounts } from '@sisrep/schemas';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const RAMA_LABELS: Record<string, string> = {
  manada: 'Manada',
  tropa: 'Tropa',
  caravana: 'Caravana',
  comunidad: 'Comunidad',
};

interface BarChartRamaProps {
  counts: PorRamaCounts;
}

export function BarChartRama({ counts }: BarChartRamaProps) {
  const data = Object.entries(counts)
    .map(([rama, count]) => ({
      rama: RAMA_LABELS[rama] ?? rama,
      count,
    }))
    .sort((a, b) => b.count - a.count);

  if (data.length === 0) {
    return <p className="text-center py-8 text-gray-500">Sin datos por rama.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
        <XAxis dataKey="rama" tick={{ fontSize: 12 }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
        <Tooltip />
        <Bar dataKey="count" fill="#a8284c" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
